import { PrivateBlogFactory } from './privateBlogFactory';

import type {
  PrivateBlogEntity,
  PrivateBlogProps,
} from './privateBlogEntity';
import type { PrivateBlogIRepository } from './privateBlogIRepository';
import type { EntityDataType } from '@/infra/appsync';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

import { AppsyncRepositoryPvt } from '@/domain/appsyncRepositoryPvt';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * ホームページレポジトリ
 */
export class PrivateBlogRepository extends AppsyncRepositoryPvt<
  PrivateBlogEntity,
  PrivateBlogProps,
  PrivateBlogJson
> implements PrivateBlogIRepository {
  private factory = new PrivateBlogFactory();

  /**
   * Entity名
   */
  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryPrivateBlogPrivateBlogEntity;
    return name;
  }

  /**
   * データからEntity生成
   * @param props データ
   * @returns Entity
   */
  protected createFromEntityDataType = (
    props: EntityDataType,
  ) => this.factory.createFromEntityDataType(props);
}
